import PicMain from "../../picSearch/PicMain";
const PicSearch=()=>{
    return(
        <div>
            <PicMain />
        </div>
    )
}
export default PicSearch;